export default function zeroPad(length, number) {
  let result = `${number}`;
  while (result.length < length) {
    result = `0${result}`;
  }
  return result;
}
export function zeropad2(number) {
  return zeroPad(2, number);
}